import { ELECTRON_MODE } from "@constants";
import { useSnapshot } from "valtio";

import { useEffect } from "react";

import { kioskStore, setIsKioskMustUpdate } from "@pages/Kiosk/store";

export default function useCheckForUpdate(): void {
    const { isProjectMustBeUpdated, isKioskMustUpdate } =
        useSnapshot(kioskStore);

    useEffect(() => {
        if (
            process.env.REACT_APP_MODE === ELECTRON_MODE &&
            isKioskMustUpdate &&
            !isProjectMustBeUpdated.setting &&
            !isProjectMustBeUpdated.peripheral
        ) {
            (window as RendererWindow).electronAPI?.checkForUpdate();
            setIsKioskMustUpdate(false);
        }
    }, [isKioskMustUpdate]);
}
